import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type BaseView = {
  '@id': string;
  '@type': 'TicketLabel';
  id: string;
  name: string;
  group: string | null;
  color: string | null;
};

export function useReadCollectionPlatformWide(options?: ReadConfig) {
  return useApiRead<HydraCollection<BaseView>>(
    `/ticket-labels/platform-wide`,
    options
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<BaseView>(`/ticket-labels/${id}`, options);
}
